/** @namespace config */
import counter from '../Functions/counter.js';

const sm_id_counts = {};

export default class EngagementLogger
{
	constructor(sm_id, isAlternate, proxy, window)
	{
		this.sm_id = sm_id;
		this.sequence = (isAlternate?-1:1)*(sm_id_counts[sm_id] = (sm_id_counts[sm_id] || 0) + 1);
		this.proxy = proxy;
		this.window = window;
		this.onUnload = () => { this.destroy(true); };
		window.addEventListener('unload',this.onUnload);
		this.counter = counter({0:10,60:60});
		this.interval = setInterval(()=>this.check(),500);
		this.next = this.counter.next();
		this.check(true);
	}

	destroy(unloading)
	{
		clearInterval(this.interval);
		this.check(true,!!unloading);
		if(!unloading)
		{
			this.window.removeEventListener('unload', this.onUnload);
		}
	}

	check(forceLog,unloading)
	{
		if(unloading)
		{
			forceLog = true;
		}

		const viewed = this.proxy.playedTotal | 0;

		if((viewed >= this.next.value.sum) || forceLog)
		{
			config.log.ENGAGEMENT
			(
				{
				SM_ID: this.sm_id,
				SAE_seq: this.sequence,
				SAE_viewed: viewed,
				},
				unloading
			);

			this.next = this.counter.next();
		}
	}
}
